export const countryUpdated = [
  {
    name: 'Algeria',
    locationId: 2012,
    code: 'DZ',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Algeria',
    locationId: 2012,
    code: 'DZ',
    language_name: 'Arabic',
    language_code: 'ar'
  },
  {
    name: 'Angola',
    locationId: 2024,
    code: 'AO',
    language_name: 'Portuguese',
    language_code: 'pt'
  },
  {
    name: 'Azerbaijan',
    locationId: 2031,
    code: 'AZ',
    language_name: 'Azeri',
    language_code: 'az'
  },
  {
    name: 'Argentina',
    locationId: 2032,
    code: 'AR',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Australia',
    locationId: 2036,
    code: 'AU',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Austria',
    locationId: 2040,
    code: 'AT',
    language_name: 'German',
    language_code: 'de'
  },
  {
    name: 'Bahrain',
    locationId: 2048,
    code: 'BH',
    language_name: 'Arabic',
    language_code: 'ar'
  },
  {
    name: 'Bangladesh',
    locationId: 2050,
    code: 'BD',
    language_name: 'Bengali',
    language_code: 'bn'
  },
  {
    name: 'Armenia',
    locationId: 2051,
    code: 'AM',
    language_name: 'Armenian',
    language_code: 'hy'
  },
  {
    name: 'Belgium',
    locationId: 2056,
    code: 'BE',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Belgium',
    locationId: 2056,
    code: 'BE',
    language_name: 'Dutch',
    language_code: 'nl'
  },
  {
    name: 'Belgium',
    locationId: 2056,
    code: 'BE',
    language_name: 'German',
    language_code: 'de'
  },
  {
    name: 'Bolivia',
    locationId: 2068,
    code: 'BO',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Brazil',
    locationId: 2076,
    code: 'BR',
    language_name: 'Portuguese',
    language_code: 'pt'
  },
  {
    name: 'Bulgaria',
    locationId: 2100,
    code: 'BG',
    language_name: 'Bulgarian',
    language_code: 'bg'
  },
  {
    name: 'Myanmar (Burma)',
    locationId: 2104,
    code: 'MM',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Cambodia',
    locationId: 2116,
    code: 'KH',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Cameroon',
    locationId: 2120,
    code: 'CM',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Canada',
    locationId: 2124,
    code: 'CA',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Canada',
    locationId: 2124,
    code: 'CA',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Sri Lanka',
    locationId: 2144,
    code: 'LK',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Chile',
    locationId: 2152,
    code: 'CL',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Taiwan',
    locationId: 2158,
    code: 'TW',
    language_name: 'Chinese (Traditional)',
    language_code: 'zh-TW'
  },
  {
    name: 'Colombia',
    locationId: 2170,
    code: 'CO',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Costa Rica',
    locationId: 2188,
    code: 'CR',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Croatia',
    locationId: 2191,
    code: 'HR',
    language_name: 'Croatian',
    language_code: 'hr'
  },
  {
    name: 'Cyprus',
    locationId: 2196,
    code: 'CY',
    language_name: 'Greek',
    language_code: 'el'
  },
  {
    name: 'Cyprus',
    locationId: 2196,
    code: 'CY',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Czechia',
    locationId: 2203,
    code: 'CZ',
    language_name: 'Czech',
    language_code: 'cs'
  },
  {
    name: 'Denmark',
    locationId: 2208,
    code: 'DK',
    language_name: 'Danish',
    language_code: 'da'
  },
  {
    name: 'Ecuador',
    locationId: 2218,
    code: 'EC',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'El Salvador',
    locationId: 2222,
    code: 'SV',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Estonia',
    locationId: 2233,
    code: 'EE',
    language_name: 'Estonian',
    language_code: 'et'
  },
  {
    name: 'Finland',
    locationId: 2246,
    code: 'FI',
    language_name: 'Finnish',
    language_code: 'fi'
  },
  {
    name: 'France',
    locationId: 2250,
    code: 'FR',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Germany',
    locationId: 2276,
    code: 'DE',
    language_name: 'German',
    language_code: 'de'
  },
  {
    name: 'Ghana',
    locationId: 2288,
    code: 'GH',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Greece',
    locationId: 2300,
    code: 'GR',
    language_name: 'Greek',
    language_code: 'el'
  },
  {
    name: 'Greece',
    locationId: 2300,
    code: 'GR',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Guatemala',
    locationId: 2320,
    code: 'GT',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Hong Kong',
    locationId: 2344,
    code: 'HK',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Hong Kong',
    locationId: 2344,
    code: 'HK',
    language_name: 'Chinese (Traditional)',
    language_code: 'zh-TW'
  },
  {
    name: 'Hungary',
    locationId: 2348,
    code: 'HU',
    language_name: 'Hungarian',
    language_code: 'hu'
  },
  {
    name: 'India',
    locationId: 2356,
    code: 'IN',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'India',
    locationId: 2356,
    code: 'IN',
    language_name: 'Hindi',
    language_code: 'hi'
  },
  {
    name: 'Indonesia',
    locationId: 2360,
    code: 'ID',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Indonesia',
    locationId: 2360,
    code: 'ID',
    language_name: 'Indonesian',
    language_code: 'id'
  },
  {
    name: 'Ireland',
    locationId: 2372,
    code: 'IE',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Israel',
    locationId: 2376,
    code: 'IL',
    language_name: 'Hebrew',
    language_code: 'he'
  },
  {
    name: 'Israel',
    locationId: 2376,
    code: 'IL',
    language_name: 'Arabic',
    language_code: 'ar'
  },
  {
    name: 'Italy',
    locationId: 2380,
    code: 'IT',
    language_name: 'Italian',
    language_code: 'it'
  },
  {
    name: "Cote d'Ivoire",
    locationId: 2384,
    code: 'CI',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Japan',
    locationId: 2392,
    code: 'JP',
    language_name: 'Japanese',
    language_code: 'ja'
  },
  {
    name: 'Kazakhstan',
    locationId: 2398,
    code: 'KZ',
    language_name: 'Russian',
    language_code: 'ru'
  },
  {
    name: 'Jordan',
    locationId: 2400,
    code: 'JO',
    language_name: 'Arabic',
    language_code: 'ar'
  },
  {
    name: 'Kenya',
    locationId: 2404,
    code: 'KE',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'South Korea',
    locationId: 2410,
    code: 'KR',
    language_name: 'Korean',
    language_code: 'ko'
  },
  {
    name: 'Latvia',
    locationId: 2428,
    code: 'LV',
    language_name: 'Latvian',
    language_code: 'lv'
  },
  {
    name: 'Lithuania',
    locationId: 2440,
    code: 'LT',
    language_name: 'Lithuanian',
    language_code: 'lt'
  },
  {
    name: 'Malaysia',
    locationId: 2458,
    code: 'MY',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Malaysia',
    locationId: 2458,
    code: 'MY',
    language_name: 'Malay',
    language_code: 'ms'
  },
  {
    name: 'Malta',
    locationId: 2470,
    code: 'MT',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Mexico',
    locationId: 2484,
    code: 'MX',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Morocco',
    locationId: 2504,
    code: 'MA',
    language_name: 'Arabic',
    language_code: 'ar'
  },
  {
    name: 'Morocco',
    locationId: 2504,
    code: 'MA',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Netherlands',
    locationId: 2528,
    code: 'NL',
    language_name: 'Dutch',
    language_code: 'nl'
  },
  {
    name: 'New Zealand',
    locationId: 2554,
    code: 'NZ',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Nicaragua',
    locationId: 2558,
    code: 'NI',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Nigeria',
    locationId: 2566,
    code: 'NG',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Norway',
    locationId: 2578,
    code: 'NO',
    language_name: 'Norwegian (Bokmål)',
    language_code: 'nb'
  },
  {
    name: 'Pakistan',
    locationId: 2586,
    code: 'PK',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Pakistan',
    locationId: 2586,
    code: 'PK',
    language_name: 'Urdu',
    language_code: 'ur'
  },
  {
    name: 'Panama',
    locationId: 2591,
    code: 'PA',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Paraguay',
    locationId: 2600,
    code: 'PY',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Peru',
    locationId: 2604,
    code: 'PE',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Philippines',
    locationId: 2608,
    code: 'PH',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Philippines',
    locationId: 2608,
    code: 'PH',
    language_name: 'Tagalog',
    language_code: 'tl'
  },
  {
    name: 'Poland',
    locationId: 2616,
    code: 'PL',
    language_name: 'Polish',
    language_code: 'pl'
  },
  {
    name: 'Portugal',
    locationId: 2620,
    code: 'PT',
    language_name: 'Portuguese',
    language_code: 'pt'
  },
  {
    name: 'Romania',
    locationId: 2642,
    code: 'RO',
    language_name: 'Romanian',
    language_code: 'ro'
  },
  {
    name: 'Saudi Arabia',
    locationId: 2682,
    code: 'SA',
    language_name: 'Arabic',
    language_code: 'ar'
  },
  {
    name: 'Senegal',
    locationId: 2686,
    code: 'SN',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Serbia',
    locationId: 2688,
    code: 'RS',
    language_name: 'Serbian',
    language_code: 'sr'
  },
  {
    name: 'Singapore',
    locationId: 2702,
    code: 'SG',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Singapore',
    locationId: 2702,
    code: 'SG',
    language_name: 'Chinese (Simplified)',
    language_code: 'zh-CN'
  },
  {
    name: 'Slovakia',
    locationId: 2703,
    code: 'SK',
    language_name: 'Slovak',
    language_code: 'sk'
  },
  {
    name: 'Vietnam',
    locationId: 2704,
    code: 'VN',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Vietnam',
    locationId: 2704,
    code: 'VN',
    language_name: 'Vietnamese',
    language_code: 'vi'
  },
  {
    name: 'Slovenia',
    locationId: 2705,
    code: 'SI',
    language_name: 'Slovenian',
    language_code: 'sl'
  },
  {
    name: 'South Africa',
    locationId: 2710,
    code: 'ZA',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Spain',
    locationId: 2724,
    code: 'ES',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Sweden',
    locationId: 2752,
    code: 'SE',
    language_name: 'Swedish',
    language_code: 'sv'
  },
  {
    name: 'Switzerland',
    locationId: 2756,
    code: 'CH',
    language_name: 'German',
    language_code: 'de'
  },
  {
    name: 'Switzerland',
    locationId: 2756,
    code: 'CH',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Switzerland',
    locationId: 2756,
    code: 'CH',
    language_name: 'Italian',
    language_code: 'it'
  },
  {
    name: 'Thailand',
    locationId: 2764,
    code: 'TH',
    language_name: 'Thai',
    language_code: 'th'
  },
  {
    name: 'United Arab Emirates',
    locationId: 2784,
    code: 'AE',
    language_name: 'Arabic',
    language_code: 'ar'
  },
  {
    name: 'United Arab Emirates',
    locationId: 2784,
    code: 'AE',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'Tunisia',
    locationId: 2788,
    code: 'TN',
    language_name: 'Arabic',
    language_code: 'ar'
  },
  {
    name: 'Turkiye',
    locationId: 2792,
    code: 'TR',
    language_name: 'Turkish',
    language_code: 'tr'
  },
  {
    name: 'Ukraine',
    locationId: 2804,
    code: 'UA',
    language_name: 'Ukrainian',
    language_code: 'uk'
  },
  {
    name: 'Ukraine',
    locationId: 2804,
    code: 'UA',
    language_name: 'Russian',
    language_code: 'ru'
  },
  {
    name: 'North Macedonia',
    locationId: 2807,
    code: 'MK',
    language_name: 'Macedonian',
    language_code: 'mk'
  },
  {
    name: 'Egypt',
    locationId: 2818,
    code: 'EG',
    language_name: 'Arabic',
    language_code: 'ar'
  },
  {
    name: 'Egypt',
    locationId: 2818,
    code: 'EG',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'United Kingdom',
    locationId: 2826,
    code: 'GB',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'United States',
    locationId: 2840,
    code: 'US',
    language_name: 'English',
    language_code: 'en'
  },
  {
    name: 'United States',
    locationId: 2840,
    code: 'US',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Burkina Faso',
    locationId: 2854,
    code: 'BF',
    language_name: 'French',
    language_code: 'fr'
  },
  {
    name: 'Uruguay',
    locationId: 2858,
    code: 'UY',
    language_name: 'Spanish',
    language_code: 'es'
  },
  {
    name: 'Venezuela',
    locationId: 2862,
    code: 'VE',
    language_name: 'Spanish',
    language_code: 'es'
  }
];
